var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"component"},[_vm._l((_vm.playlists),function(playlist){return [_c('v-card',{staticClass:"mb-2"},[_c('v-card-text',[_c('playlist',{attrs:{"playlist":playlist}})],1)],1)]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }